'use client'
import { Individualprofile, Publicprofile } from '@/payload-types'
import Image from 'next/image'
import SeeProfileBtn from '../button/seeProfileBtn'
import { RenderPublicDetails } from '@/components/public-profile-card/profileDetails'
import { ImageComponent } from '../media/imageComponent'
import { TypesenseData } from '@/lib/typesenseFunction'
import PopupComponent from '../popup/popup'
import { useState } from 'react'
interface IProps {
  profileData: (string | null) | Publicprofile | TypesenseData
  profilePicture?: { pictureDivCSS?: string; pictureCSS?: string; sizes?: string; isPriority?: boolean }
  profileFullName?: { fullNameDivCSS?: string; fullNameCSS?: string }
  moreDetails?: {
    ifShow?: boolean
    ifFlex?: boolean
    value: { label: string | null; value: string | null }[]
    showMore?: boolean
    detailsCSS?: string
    allItems?: boolean
  }
  profileDescription?: { ifShow?: boolean; descriptionNode?: React.ReactNode }
  seeProfileBtn?: { ifShow?: boolean; btnCSS?: string; href?: string }
  informationCSS?: string
  openImagePopup?: boolean
}

export const ProfileCardComponent = ({
  profileData,
  profilePicture,
  profileFullName,
  moreDetails = {
    ifShow: false,
    ifFlex: false,
    value: [
      {
        label: null,
        value: null,
      },
    ],
  },
  profileDescription = { ifShow: false },
  seeProfileBtn = { ifShow: false },
  informationCSS,
  openImagePopup = false,
}: IProps) => {
  const [showImagePopup, setShowImagePopup] = useState(false)
  const baseUrl = process.env.NEXT_PUBLIC_PAYLOAD_URL || ''
  let imageUrl, imageAlt, fullName, href, imagePopupUrl

  if (profileData && typeof profileData === 'object') {
    const entity = (profileData as Publicprofile).profileEntity as Individualprofile || profileData as Publicprofile;
    const status = entity.status || '';
    const isProfessor = status.includes('Professor');
  
    href = `/` + (isProfessor ? `professor/${profileData.slug}` : `individual/${profileData.slug}`);
    fullName = entity.fullName || '';
    imageAlt = entity.fullName || 'Profile Image';
  
    if (profileData.profileImage && typeof profileData.profileImage === 'object') {
      imageUrl = `${baseUrl}${profileData.profileImage.sizes?.webp?.url || ''}`;
      imagePopupUrl = `${baseUrl}${profileData.profileImage.sizes?.medium?.url || ''}`;
    } else {
      imageUrl = profileData.profileImage || '';
      imagePopupUrl = '';
    }
  }
  return (
    <>
      <div className={`relative ${profilePicture?.pictureDivCSS}`}>
        {openImagePopup && showImagePopup && (
          <PopupComponent onClose={() => setShowImagePopup(false)}>
            <ImageComponent
              src={imagePopupUrl ? imagePopupUrl : ''}
              alt={imageAlt ? imageAlt : ''}
            />
          </PopupComponent>
        )}
        {imageUrl && (
          <Image
            src={imageUrl}
            alt={imageAlt ?? ''}
            fill
            sizes={profilePicture?.sizes ?? '(max-width: 767px) 120px, (max-width: 1279px) 160px, 220px'}
            preload={profilePicture?.isPriority}
            fetchPriority={profilePicture?.isPriority ? 'high' : undefined}
            decoding={profilePicture?.isPriority ? 'sync' : 'async'}
            loading={profilePicture?.isPriority ? 'eager' : 'lazy'}
            className={`${profilePicture?.pictureCSS} object-cover ${
              openImagePopup ? 'cursor-pointer' : ''
            }`}
            onClick={() => {
              if (openImagePopup) setShowImagePopup(true)
            }}
          />
        )}
        {profileData &&
          typeof profileData === 'object' &&
          'region' in profileData &&
          profileData.region === 'Canada' && (
            <div className="absolute rounded-[2px] w-[25px] h-[17px] bottom-[13px] right-[10px] shadow-[0_3px_4px_rgba(0,0,0,1)]">
              <Image
                src={'https://cm2cdn.canarymission.org/static/images/canada-flag-icon.svg'}
                alt={'ddd'}
                height={50}
                width={50}
              />
            </div>
          )}
      </div>
      <div className={`flex-1 ${informationCSS}`}>
        <div className={profileFullName?.fullNameDivCSS}>
          <span className={profileFullName?.fullNameCSS}>{fullName}</span>
        </div>
        {moreDetails.ifShow && (
          <div className={moreDetails.detailsCSS}>
            <RenderPublicDetails
              ifFlex={moreDetails.ifFlex}
              arrayOfData={moreDetails.value}
              showMore={moreDetails.showMore}
            />
          </div>
        )}
        {profileDescription?.ifShow && profileDescription?.descriptionNode}
        <SeeProfileBtn
          show={seeProfileBtn?.ifShow}
          href={seeProfileBtn?.href ? seeProfileBtn?.href : href}
          buttonCSS={seeProfileBtn?.btnCSS}
        />
      </div>
    </>
  )
}

export default ProfileCardComponent
